import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { SettingsProvider } from "./context/SettingsContext";
import { AdminAuthProvider, useAdminAuth } from "./context/AdminAuthContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { Leaf } from "lucide-react";

import Home from "./pages/Home";
import Catalogo from "./pages/Catalogo";
import Categorie from "./pages/Categorie";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderConfirmed from "./pages/OrderConfirmed";
import PaymentFailed from "./pages/PaymentFailed";
import Privacy from "./pages/Privacy";
import Termini from "./pages/Termini";
import HerbalifeRossano from "./pages/HerbalifeRossano";
import ContactDistributore from "./pages/ContactDistributore";
import ChiSiamo from "./pages/ChiSiamo";
import Faq from "./pages/Faq";
import Spedizioni from "./pages/Spedizioni";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminOrderDetail from "./pages/admin/AdminOrderDetail";
import AdminSettings from "./pages/admin/AdminSettings";

function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1"><Outlet /></main>
      <Footer />
    </div>
  );
}

function AdminRoute({ children }) {
  const { admin, loading } = useAdminAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><Leaf className="w-10 h-10 text-primary animate-pulse" /></div>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <SettingsProvider>
        <AdminAuthProvider>
          <CartProvider>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/catalogo" element={<Catalogo />} />
                <Route path="/categorie" element={<Categorie />} />
                <Route path="/prodotto/:slug" element={<ProductDetail />} />
                <Route path="/herbalife-rossano" element={<HerbalifeRossano />} />
                <Route path="/chi-siamo" element={<ChiSiamo />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/spedizioni" element={<Spedizioni />} />
                <Route path="/contatta-il-distributore" element={<ContactDistributore />} />
                <Route path="/carrello" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/ordine-confermato" element={<OrderConfirmed />} />
                <Route path="/pagamento-fallito" element={<PaymentFailed />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/termini" element={<Termini />} />
              </Route>

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
                <Route index element={<AdminDashboard />} />
                <Route path="prodotti" element={<AdminProducts />} />
                <Route path="categorie" element={<AdminCategories />} />
                <Route path="ordini" element={<AdminOrders />} />
                <Route path="ordini/:id" element={<AdminOrderDetail />} />
                <Route path="impostazioni" element={<AdminSettings />} />
              </Route>
            </Routes>
          </CartProvider>
        </AdminAuthProvider>
      </SettingsProvider>
    </BrowserRouter>
  );
}

export default App;
